export default {
  SUPPORT_PROVIDED: 'supportProvided'
}